import { Card, Flex, Grid } from '@utilitywarehouse/hearth-react';
import {
  TickMediumIcon,
  TickSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import { semantic } from '@utilitywarehouse/hearth-tokens/browser';

import {
  SlideHeading,
  Terms,
} from '@components/PresentationRebrand/ContentSlide/slides/shared';
import {
  Feature,
  Features,
} from '@components/PresentationRebrand/ContentSlide/slides/shared/Features';
import { useBreakpoints } from '@utils/useBreakpoints.ts';

import './styles.scss';

type Review = {
  id: string;
  src: string;
  alt: string;
};

const Check = () => {
  const { breakpointsDown } = useBreakpoints();
  const Icon = breakpointsDown.sm ? TickSmallIcon : TickMediumIcon;

  return (
    <Flex
      padding={{ mobile: '100', tablet: '150' }}
      borderRadius="md"
      borderStyle="solid"
      borderWidth="2"
      borderColor="strong"
      backgroundColor={semantic.surface.broadband.default}
    >
      <Icon />
    </Flex>
  );
};

const FEATURES: Feature[] = [
  {
    id: '1',
    icon: <Check />,
    title: "'Excellent' on TrustPilot from 67,000 + reviews.",
  },
  {
    id: '2',
    icon: <Check />,
    title: 'Over 80 awards and counting.',
  },
  {
    id: '3',
    icon: <Check />,
    title: 'Speak to a real human from an award-winning team.',
  },
  {
    id: '4',
    icon: <Check />,
    title: 'Five-star-rated by Defaqto and Moneyfacts.',
  },
  {
    id: '5',
    icon: <Check />,
    title: "We'll plant a tree in your name when you join with three services.",
  },
  {
    id: '6',
    icon: <Check />,
    title:
      'A real British success story - 30 years strong, helping over one million customers.',
  },
];

const REVIEWS: Review[] = [
  {
    id: 'expertreviews',
    src: '/Presentation/Households/expertreviews.png',
    alt: 'Expert reviews, best value energy supplier winner, home energy awards 2025',
  },
  {
    id: 'defaqto',
    src: '/Presentation/Households/defaqto.png',
    alt: 'defaqto, five stars, home energy insurance 2017-2026, expert rated',
  },
  {
    id: 'trustpilot',
    src: '/Presentation/Households/trustpilot.png',
    alt: 'Utility Warehouse is rated great, Trustpilot',
  },
  {
    id: 'moneyfacts-hi',
    src: '/Presentation/Households/moneyfacts-hi.png',
    alt: 'Moneyfacts, five star product rating, home insurance 2018-2026',
  },
  {
    id: 'moneyfacts-hec',
    src: '/Presentation/Households/moneyfacts-hec.png',
    alt: 'Moneyfacts, five star product rating, home emergency cover 2026',
  },
];

export const Households = () => (
  <Flex direction="column">
    <Grid
      templateColumns={{ mobile: '1fr', desktop: '3fr 2fr' }}
      gap={{ tablet: '500' }}
    >
      <Flex direction="column">
        <Flex marginBottom={{ mobile: '250', tablet: '400', desktop: '500' }}>
          <SlideHeading>Join one million households</SlideHeading>
        </Flex>

        <Features features={FEATURES} />
      </Flex>

      <Grid
        className="households__reviews"
        marginTop={{ mobile: '200', tablet: '0', desktop: '200' }}
        marginBottom="250"
      >
        {REVIEWS.map(({ id, src, alt }) => (
          <Card
            key={id}
            paddingNone
            variant="emphasis"
            colorScheme="neutralStrong"
            gridArea={id}
            className="households__reviews__card"
          >
            <img className="households__reviews__image" src={src} alt={alt} />
          </Card>
        ))}
      </Grid>
    </Grid>

    <Terms />
  </Flex>
);
